export default "__VITE_ASSET__DKbmEVC8__"